import type { RouterClient } from "@orpc/server";
import type { BlogApiRouter } from "./router/blog.js";
import type { ContactApiRouter } from "./router/contact.js";

export type BaseApiClient = {
  blog: RouterClient<BlogApiRouter>;
  contact: RouterClient<ContactApiRouter>;
};

export const getBaseApiClient = (): BaseApiClient | undefined =>
  (globalThis as typeof globalThis & { $client?: BaseApiClient }).$client;
